import styled from '@emotion/styled';

import { button, maxWidthAndCenter } from '@styles';

const HeroContainer = styled.div`
  position: relative;
  padding: 10.25rem 0 15.25rem;

  .hero__h2 {
    padding: 0 0 1.25rem;
    font-size: 2rem;
    font-weight: 700;
    color: var(--orange);
    line-height: 1;
    text-transform: uppercase;
  }

  .hero__h1 {
    max-width: 50%;
    font-size: clamp(2rem, 4vw, 5rem);
    font-weight: 900;
    color: white;
    line-height: 1;
    text-transform: uppercase;
    text-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 0.35);
  }

  .hero__link {
    margin: 3rem 0 0 0;
    max-width: 100%;
    min-width: 30rem;
    ${button('orange')}
  }

  .hero__content {
    position: relative;
    z-index: 1;
    ${maxWidthAndCenter}
  }

  .hero__background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .hero__gradient {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(
      to right,
      rgba(50, 74, 93, 1) 0%,
      rgba(50, 74, 93, 1) 50%,
      rgba(50, 74, 93, 0) 80%
    );
  }

  .hero__image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    max-width: 75%;
  }

  &.hero--slim {
    padding: 7rem 0 7rem;

    .hero__h1 {
      max-width: 100%;
    }

    .hero__image {
      left: 0;
      max-width: 100%;
      filter: brightness(0.4);
    }
  }

  @media screen and (max-width: 1470px) {
    padding: 10.25rem 2rem 15.25rem;

    &.hero--slim {
      padding: 7rem 2rem;
    }
  }

  @media screen and (max-width: 1024px) {
    .hero__h1 {
      width: auto;
      max-width: 60%;
    }
  }

  @media screen and (max-width: 700px) {
    padding: 2rem 1.5rem;

    &.hero--slim {
      padding: 4rem 2rem;

      .hero__content {
        min-height: auto;
      }

      .hero__image {
        top: 0%;
      }
    }

    .hero__gradient {
      background: linear-gradient(
        to bottom,
        rgba(50, 74, 93, 1) 0%,
        rgba(50, 74, 93, 1) 25%,
        rgba(50, 74, 93, 0) 45%
      );
    }

    .hero__content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 36rem;
    }

    .hero__h2 {
      max-width: 100%;
      font-size: 1.25rem;
    }

    .hero__h1 {
      max-width: 100%;
      font-weight: 800;
    }

    .hero__image {
      top: 20%;
      max-width: 100%;
    }

    .hero__link {
      max-width: 100%;
      min-width: 0;
      padding: 0.75rem 1rem;
      font-size: 1rem;
    }
  }
`;

export { HeroContainer };
